import { FunctionComponent, Ref, useState } from 'react';
import { Button, spacingHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';

const UserActionComponentWrapper = styled.div`
  align-self: flex-end;
  justify-content: end;
  padding-left: ${spacingHelper('medium')};
  padding-right: ${spacingHelper('medium')};
  width: 90%;
  gap: ${spacingHelper('extraSmall')};
  display: flex;
  flex-wrap: wrap;
`;

interface UserActionButtonsProps {
  actions: string[];
  onActionClick: (action: string) => void;
  userInteractionRef?: Ref<HTMLDivElement>;
}

export const UserActionButtons: FunctionComponent<UserActionButtonsProps> = ({
  actions,
  onActionClick,
  userInteractionRef,
}) => {
  const [clicked, setClicked] = useState<string | null>(null);

  const handleClick = (action: string) => {
    if (clicked === null) {
      setClicked(action);
      onActionClick(action);
    }
  };

  return (
    <UserActionComponentWrapper ref={userInteractionRef}>
      {actions.map((action, index) => (
        <Button
          key={index}
          variant="outline-secondary"
          sizeVariant="medium"
          disabled={clicked !== null && clicked !== action}
          onClick={() => !clicked && handleClick(action)}
        >
          {action}
        </Button>
      ))}
    </UserActionComponentWrapper>
  );
};
